import { Features } from 'common/features'

export const TOGGLE_OVERRIDES = 'TOGGLE_OVERRIDES'
export const USER_ID = 'USER_ID'

export type StoredFeatureOverrides = {
    [feature in Features]?: { serverState: boolean; overrideValue: boolean }
}

export interface LocalStorageTypes {
    TOGGLE_OVERRIDES: StoredFeatureOverrides
    USER_ID: string | null
}

export function getItem<T extends keyof LocalStorageTypes>(key: T, fallback: LocalStorageTypes[T]) {
    let savedValue: string | null = null
    try {
        savedValue = localStorage.getItem(key)
    } catch (e) {}
    if (savedValue) {
        try {
            return JSON.parse(savedValue) as LocalStorageTypes[T]
        } catch (error) {
            // taking a pessimistic approach to localStorage
        }
    }

    return fallback
}

export function setItem<T extends keyof LocalStorageTypes>(key: T, value: LocalStorageTypes[T]) {
    try {
        localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
        // we won't necessarily have quota to setItem (eg: Safari private browsing)
    }
}
